{
  "info": "Πληροφορίες",
  "negative": "Σφάλμα",
  "notice": "Προειδοποίηση",
  "positive": "Επιτυχία"
}
